// Based on Meteor's EJSON implementation: https://github.com/meteor/meteor
//
//    packages/oauth/oauth_browser.js
//    2018-01-18
//
// The MIT License (MIT)
//
// Copyright (c) 2011 - 2017 Meteor Development Group, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

const openCenteredPopup = function openCenteredPopup(url, width, height) {
  const screenX =
    typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft;
  const screenY =
    typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop;
  const outerWidth =
    typeof window.outerWidth !== 'undefined'
      ? window.outerWidth
      : document.body.clientWidth;
  const outerHeight =
    typeof window.outerHeight !== 'undefined'
      ? window.outerHeight
      : document.body.clientHeight - 22;
  // XXX what is the 22?

  // Use `outerWidth - width` and `outerHeight - height` for help in
  // positioning the popup centered relative to the current window
  const left = screenX + (outerWidth - width) / 2;
  const top = screenY + (outerHeight - height) / 2;
  const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`;
  const newWindow = window.open(url, 'Login', features);

  if (!newWindow) {
    // blocked by a popup blocker maybe?
    const err = new Error('The login popup was blocked by the browser');
    err.attemptedUrl = url;
    throw err;
  }

  if (newWindow.focus) {
    newWindow.focus();
  }

  return newWindow;
};

// Browser specific code for the OAuth package.

// Open a popup window, centered on the screen, and call a callback when it
// closes.
//
// @param url {String} url to show
// @param callback {Function} Callback function to call on completion. Takes no
//   arguments.
// @param dimensions {optional Object(width, height)} The dimensions of
//   the popup. If not passed defaults to something sane.
export function showPopup(url, callback, dimensions) {
  // default dimensions that worked well for facebook and google
  const popup = openCenteredPopup(
    url,
    (dimensions && dimensions.width) || 650,
    (dimensions && dimensions.height) || 331,
  );

  let popupClosed;

  const checkPopupOpen = setInterval(() => {
    try {
      // Fix for #328 - added a second test criteria (popup.closed === undefined)
      // to humour this Android quirk:
      // http://code.google.com/p/android/issues/detail?id=21061
      popupClosed = popup.closed || popup.closed === undefined;
    } catch (e) {
      // For some unknown reason, IE9 (and others?) sometimes (when
      // the popup closes too quickly?) throws "SCRIPT16386: No such
      // interface supported" when trying to read 'popup.closed'. Try
      // again in 100ms.
      return;
    }

    if (popupClosed) {
      clearInterval(checkPopupOpen);
      callback();
    }
  }, 100);
}
